import { ref } from 'vue'

export function useModalControl() {
  // 1. Create the ref to hold the component instance
  const componentRef = ref(null)

  // 2. Define the methods that interact with that ref
  const openModal = () => {
    // Optional chaining (?.) prevents errors if the component isn't mounted yet
    componentRef.value?.openModal()
  }

  const closeModal = () => {
    componentRef.value?.closeModal()
  }

  // 3. Return the ref and the methods
  return {
    componentRef,
    openModal,
    closeModal
  }
}
